import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectId, ProjectConversationId } from 'api/models';
import {
  ProjectGlobalConversation,
  ProjectConversation,
} from 'api/project-conversations';
import { useProjectConversationContentUpdates } from '../../proj-conversation-hooks';
import { ConversationItem, GlobalConversationItem } from '../conv-item';
import { ListHeading, ConversationList, Conversations } from './styles';

interface Props {
  myConversations: ProjectConversation[];
  otherConversations: ProjectConversation[];
  projectId: ProjectId;
  conversationId?: ProjectConversationId;
  globalConversations?: ProjectGlobalConversation[];
}
export const ConversationNameList: FC<Props> = ({
  myConversations,
  otherConversations,
  projectId,
  conversationId,
  globalConversations,
}) => {
  const convItemupdates = useProjectConversationContentUpdates(
    projectId,
    conversationId,
  );

  return (
    <Conversations>
      {myConversations.length > 0 && (
        <ConversationList>
          <ListHeading>
            <FormattedMessage id="projects.conversations.member" />
          </ListHeading>
          {myConversations.map((conversation) => (
            <ConversationItem
              realtimeUnreadCount={
                convItemupdates[conversation.conversationId]?.unreadCount
              }
              conversation={conversation}
              key={conversation.conversationId}
              projectId={projectId}
            />
          ))}
        </ConversationList>
      )}
      {otherConversations.length > 0 && (
        <ConversationList>
          <ListHeading>
            <FormattedMessage id="projects.conversations.non_member" />
          </ListHeading>
          {otherConversations.map((conversation) => (
            <ConversationItem
              realtimeUnreadCount={
                convItemupdates[conversation.conversationId]?.unreadCount
              }
              conversation={conversation}
              key={conversation.conversationId}
              projectId={projectId}
            />
          ))}
        </ConversationList>
      )}
      {(globalConversations?.length ?? 0) > 0 && (
        <ConversationList>
          <ListHeading>
            <FormattedMessage id="projects.conversations.other" />
          </ListHeading>
          {globalConversations?.map((conversation) => (
            <GlobalConversationItem
              conversation={conversation}
              key={conversation.entityId + conversation.entityType}
              projectId={projectId}
            />
          ))}
        </ConversationList>
      )}
    </Conversations>
  );
};
